import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'antd';

import { CLOUD_ICON, DEFAULT_PLUGIN_THUMBNAIL } from '../../config/media';
import { RenderTodo } from '../PluginList/TodoConfirmation';
import { Wrapper } from './style';

const HelperModal = ({ isVisible, exchange, selectedPlugin, closeCallback, setIsInstall }) => {
    const [isOpen, setOpen] = useState(false);
    useEffect(() => {
        setOpen(isVisible);
    }, [isVisible]);
    const handleClose = () => {
        setOpen(false);
        closeCallback();
        setIsInstall(false)
    };

    const renderContent = () => {
        if (selectedPlugin.version === 0) {
            return (
                <div className="helper-modal-wrapper">
                    <div className="helper-modal-content">
                        <div>
                            {selectedPlugin.icon ? (
                                <img
                                    src={selectedPlugin.icon}
                                    className="plugin-icon"
                                    alt="plugin-icon"
                                />
                            ) : (
                                <img
                                    src={DEFAULT_PLUGIN_THUMBNAIL}
                                    className="plugin-icon"
                                    alt="plugin-icon"
                                />
                            )}
                        </div>
                        <div>
                            <h2>{selectedPlugin.name}</h2>
                            <div>This plugin is coming soon!</div>
                        </div>
                    </div>
                </div>
            )
        } else if (exchange.is_running) {
            return (
                <div className="helper-modal-wrapper plugin-list">
                    {/* <div className="description">
                        <img
                            src={
                                selectedPlugin.icon
                                    ? selectedPlugin.icon
                                    : DEFAULT_PLUGIN_THUMBNAIL
                            }
                            alt={`plugin`}
                            className="plugin-list-icon"
                        />
                    </div> */}
                    <div className="plugin-title">Add plugin on your exchange</div>
                    <div className="description">
                        To enable this plugin you must login to your exchange and add the plugin via the blue admin operator controls.
                    </div>
                    <div className="description">
                        <b>Domain currently set:</b>{' '}
                        <a href={`${exchange.domain}/admin/plugins`} target="blank">
                            {exchange.domain ? `${exchange.domain}/admin/plugins` : null}
                        </a>
                    </div>
                    <div>
                        <Button type='primary' className="back-btn" onClick={handleClose}>Back</Button>
                    </div>
                </div>
            )
        } else {
            return <RenderTodo
                exchange={exchange}
                handleClose={handleClose}
                icon={CLOUD_ICON}
                isPlugin={true}
            />
        }
    }

    return (
        <Modal
            width={450}
            visible={isOpen}
            footer={null}
            onCancel={handleClose}
        >
            <Wrapper>
                {renderContent()}
            </Wrapper>
        </Modal>
    );
}

HelperModal.defaultProps = {
    closeCallback: () => { },
    setIsInstall: () => { }
};

export default HelperModal;
